import React, { useState } from "react";
import DataIteration from "../helpers/DataIteration";
import ServicesTab from "./ServicesTab";
// import CoursesTab from "./CoursesTab";

function AboutSection() {
  const tabContent = [
    {
      id: 1,
      uniqKey: "_services",
      content: "Our Services",
      companent: <ServicesTab />,
    },
    // {
    //   id: 2,
    //   uniqKey: "_courses",
    //   content: "Online Courses",
    //   companent: <CoursesTab />,
    // },
  ];

  const [tab, setTab] = useState(tabContent[0].id);
  const tabHandler = (e, value) => {
    e.preventDefault();
    setTab(value);
  };

  return (
    <section className="about-two py-100 rpt-80 rpb-100">
      <div className="container-fluid clearfix px-70">
        <div className="row">
          <div className="col-lg-9 offset-lg-3">
            <ul className="nav about-tab justify-content-start">
              <DataIteration datas={tabContent} startLength={0} endLength={1}>
                {({ datas }) => (
                  <li
                    key={datas.id + datas.uniqKey}
                    className={
                      tab === datas.id ? "active  rounded-top" : "rounded-top"
                    }
                  >
                    <a
                      onClick={(e) => tabHandler(e, datas.id)}
                      data-toggle="tab"
                      href="#"
                    >
                      <h3>{datas.content}</h3>
                    </a>
                  </li>
                )}
              </DataIteration>
            </ul>
          </div>
        </div>

        <div className="tab-content about-tab-content">
          <DataIteration datas={tabContent} startLength={0} endLength={1}>
            {({ datas }) => (
              <div
                key={datas.id + datas.uniqKey}
                className={`tab-pane fade ${tab === datas.id ? "show active" : ""
                  }`}
                id="tabContent1"
              >
                {datas.companent}
              </div>
            )}
          </DataIteration>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
